import { Injectable } from '@angular/core';
import { PARAMS } from '../constants/storage-constants';
import { E360UrlParams } from '../models/e360-url-params.model';

@Injectable({
  providedIn: 'root'
})
export class UrlParamService {
  private _params: E360UrlParams = {
    code: undefined,
    cognitoError: undefined,
    cognitoErrorDescription: undefined,
    orgIdpExternalId: undefined,
    newUserIdpId: undefined,
    functionName: undefined,
    functionId: undefined,
    defaultStoreId: undefined,
    defaultStoreIdType: undefined,
    moduleId: undefined,
    from: undefined
  };

  get code(): string {
    return this._params.code;
  }

  get cognitoError(): string {
    return this._params.cognitoError;
  }

  get cognitoErrorDescription(): string {
    return this._params.cognitoErrorDescription;
  }

  get orgIdpExternalId(): string {
    return this._params.orgIdpExternalId;
  }

  get newUserIdpId(): string {
    return this._params.newUserIdpId;
  }

  get functionName(): string {
    return this._params.functionName;
  }

  get functionId(): string {
    return this._params.functionId;
  }

  get defaultStoreId(): string {
    return this._params.defaultStoreId;
  }

  get defaultStoreIdType(): string {
    return this._params.defaultStoreIdType;
  }

  get moduleId(): string {
    return this._params.moduleId;
  }

  get from(): string {
    return this._params.from;
  }

  handleURLParams(search: string) {
    // existing params if user logs into e360 with SSO, redirects to go to cognito, and redirects back to e360 after successful cognito sign in
    const existingParams: E360UrlParams = JSON.parse(sessionStorage.getItem(PARAMS));

    const params = new URLSearchParams(search);
    const lowerParams = new URLSearchParams();

    for (const [name, value] of params) {
      lowerParams.append(name.toLowerCase(), value);
    }

    // these params are from re-directs and need to be checked for at all instantiations of E360
    this._params.code = lowerParams.get('code');
    this._params.cognitoError = lowerParams.get('error');
    this._params.cognitoErrorDescription = lowerParams.get('error_description');
    this._params.from = lowerParams.get('from');

    if (existingParams) {
      this._params.orgIdpExternalId = existingParams.orgIdpExternalId;
      this._params.newUserIdpId = existingParams.newUserIdpId;
      this._params.defaultStoreId = existingParams.defaultStoreId;
      this._params.defaultStoreIdType = existingParams.defaultStoreIdType;
      this._params.moduleId = existingParams.moduleId;
      this._params.functionName = existingParams.functionName;
      this._params.functionId = existingParams.functionId;
    } else {
      this._params.orgIdpExternalId = lowerParams.get('organization');
      this._params.newUserIdpId = lowerParams.get('idpid');
      this._params.defaultStoreId = lowerParams.get('storeid');
      this._params.defaultStoreIdType = lowerParams.get('storeidtype');
      this._params.moduleId = lowerParams.get('module');
      this._params.functionName = lowerParams.get('function');
      this._params.functionId = lowerParams.get('id');
    }
  }

  saveToStorage() {
    sessionStorage.setItem(PARAMS, JSON.stringify(this._params));
  }

  // TECH DEBT - this method is currently only used in unit testing. refactor to move to a test setup file.
  setParams(params: E360UrlParams) {
    const keys = Object.keys(params);
    keys.forEach(key => (this._params[key] = params[key]));
  }
}
